const PRIMARY = "#0057FF";
const SECONDARY = "#00C6D7";

export const THEME = {
    colors: {
        /* Brand Core */
        primary: PRIMARY,
        primaryHover: "#0046CC",
        primaryMedium: "#3380FF",
        primaryLight: "#EDF4FF",

        secondary: SECONDARY,
        secondaryLight: "#E0F2FE",

        accent: "#007D8A",           // Accessible cyan accent
        accentLight: "#E0FAFD",

        /* Backgrounds */
        background: "#F8FAFC",       // Soft Gray
        surface: "#FFFFFF",
        surface2: "#F1F5F9",
        surface3: "#E2E8F0",
        surface4: "#CBD5E1",

        /* Sidebar / Dark */
        dark: "#061A38",             // EsaiNex navy
        darkMedium: "#102B50",
        darkLight: "#23496A",

        /* Text */
        textPrimary: "#0F172A",      // Slate
        textSecondary: "#64748B",
        textMuted: "#94A3B8",

        onPrimary: "#FFFFFF",
        onSurface: "#0F172A",

        /* Status */
        success: "#10B981",
        warning: "#F59E0B",
        danger: "#EF4444",
        info: "#38BDF8",

        /* Utility */
        border: "#E2E8F0",
        lightgrey: "#F8FAFC",

        /* Dashboard Card Palette */
        card1: "#E0FAFD", // Cyan tint
        card2: "#EEF5FB", // Neutral blue tint
        card3: "#E8F0FF", // Electric blue tint
        card4: "#E0FAFD", // Cyan tint
        card5: "#EEF5FB",
        card6: "#E8F0FF",
        card7: "#E0FAFD",
        card8: "#EEF5FB",
        card9: "#E8F0FF",
        card10: "#E0FAFD",
        card11: "#EEF5FB",
        card12: "#E8F0FF",
        card13: "#E0FAFD",
        card14: "#EEF5FB",
        card15: "#E8F0FF",
        card16: "#E0FAFD",
        card17: "#EEF5FB",
        card18: "#E8F0FF",
        card19: "#E0FAFD",
        card20: "#EEF5FB",

        /* Gradients */
        heroGradient:
            `linear-gradient(135deg, ${PRIMARY} 0%, ${SECONDARY} 100%)`,

        premiumGradient:
            `linear-gradient(135deg, #061A38 0%, ${PRIMARY} 65%, ${SECONDARY} 100%)`,
    },

    shadows: {
        sm: "0 2px 8px rgba(15,23,42,0.05)",
        md: "0 6px 20px rgba(15,23,42,0.08)",
        lg: "0 12px 30px rgba(15,23,42,0.12)",
    },

    radius: {
        sm: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
    },

    manifest: {
        name: "EsaiNex LMS",
        short_name: "EsaiNex LMS",
        description: "EsaiNex Learning Management System",
        icons: [
            {
                src: "logo/esainex-lms-192.png",
                sizes: "192x192",
                type: "image/png",
            },
            {
                src: "logo/esainex-lms-512.png",
                sizes: "512x512",
                type: "image/png",
            },
        ],

        width: 192,

        contact: {
            email: process.env.REACT_APP_CONTACT_EMAIL,
            phone: process.env.REACT_APP_CONTACT_PHONE,
            location: process.env.REACT_APP_CONTACT_LOCATION,
        },
    },
};

export default THEME;